import { Component } from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import PropTypes from "prop-types";

export default class RefreshButton extends Component {
  timer = false;

  constructor(props) {
    super(props);

    this.state = { timerCount: 0, timerMax: props.timeOut ? props.timeOut : 5 };
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  attachIntervals = (seconds) => {
    this.props.onRefreshClick();
    this.setState({ ...this.state, timerCount: seconds });

    this.timer = setInterval(() => {
      var timerCount =
        this.state.timerCount != 0
          ? this.state.timerCount - 1
          : clearInterval(this.timer) | 0;
      this.setState({ ...this.state, timerCount });
    }, 750);
  };

  render() {
    let isRefreshingInProgress = this.state.timerCount != 0;

    return (
      <div style={{ textAlign: "right" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={this.attachIntervals.bind(this, this.state.timerMax)}
          icon={
            isRefreshingInProgress ? (
              <CircularProgress size={20} thickness={2} />
            ) : undefined
          }
        >
          refresh
        </Button>
        {isRefreshingInProgress ? (
          <LinearProgress
            mode="determinate"
            value={this.state.timerMax - this.state.timerCount}
            max={this.state.timerMax}
            min={0}
          />
        ) : undefined}
      </div>
    );
  }

  static propTypes = {
    onRefreshClick: PropTypes.func.isRequired,
    timeOut: PropTypes.number,
  };
}
